import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Modal } from 'react-bootstrap';
import { FaPhoneVolume } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

import ContactForm from "../../MainHeader/ContactForm";

const Buttonanimated = ({ text = "Contact Us" }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>

      {/* Pulsing Glow */}
      <motion.div
        animate={{
          opacity: [0.3, 0.7, 0.3],
          scale: [1, 1.08, 1],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{
          position: 'absolute',
          inset: '-6px',
          borderRadius: '14px',
          background: '#b22335',
          filter: 'blur(15px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      {/* Main Button */}
      {/* btn-lg removed, px-5 changed to px-4, py-2 changed to py-1.5 for a smaller look */}
      <motion.button
        className="btn px-4 py-1.5 fw-bold position-relative overflow-hidden"
        onClick={handleShow}
        style={{
          background: isHovered ? '#3D3B6D' : '#b22335',
          color: '#ffffff',
          border: `2px solid ${isHovered ? '#3D3B6D' : '#b22335'}`,
          borderRadius: '12px',
          fontSize: '1rem',
          letterSpacing: '0.5px',
          zIndex: 1,
          cursor: 'pointer',
          transition: 'background 0.4s ease, border-color 0.4s ease, color 0.3s ease',
        }}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        whileHover={{
          scale: 1.06,
          y: -4,
          boxShadow: `0 15px 40px rgba(178, 35, 53, 0.35)`
        }}
        whileTap={{
          scale: 0.94,
          boxShadow: `0 5px 15px rgba(178, 35, 53, 0.2)`
        }}
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 15
        }}
      >

        {/* Shimmer Effect */}
        <motion.span
          className="position-absolute"
          style={{
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
            zIndex: 2,
            pointerEvents: 'none',
          }}
          animate={{
            left: isHovered ? '100%' : '-100%',
          }}
          transition={{
            duration: 0.6,
            ease: "easeInOut"
          }}
        />

        {/* Gradient Overlay */}
        <motion.div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 50%)',
            zIndex: 1,
            pointerEvents: 'none',
          }}
          animate={{ opacity: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
        />

        {/* Button Content */}
        <span
          className="position-relative d-flex align-items-center gap-2"
          style={{ zIndex: 3 }}
        >
          {text}

          <motion.span
            animate={{
              x: isHovered ? 6 : 0,
              rotate: isHovered ? 0 : -45,
              opacity: isHovered ? 1 : 0.5,
            }}
            transition={{
              type: "spring",
              stiffness: 500,
              damping: 12
            }}
            style={{ display: 'inline-flex', fontSize: '1.2rem' }}
          >
            →
          </motion.span>
        </span>
      </motion.button>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className="modalpopup d-flex justify-content-center"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fontHauora">
            Get Your Free Estimate
          </Modal.Title>
        </Modal.Header>

        <div className="mx-auto justify-content-center my-2">
          <div className="mx-2 px-md-1 px-2 text-center mb-0 pb-0">
            <p className="text-center fontHauora mb-1">
              Please call and email us with your Details
            </p>

            <div className="my-0">
              <p className="my-0 py-0 fontLight">
                <FaPhoneVolume className="phone-icon ms-1 me-1" />
                <span className="phone-number fontLight">
                  614-357-7539
                </span>
              </p>

              <p className="d-flex align-items-center gap-1 text-center justify-content-center fontLight pb-0 mb-0">
                <MdEmail className="color" />
                <span className="fontLight">
                  roofs@ultimatesroofing.com
                </span>
              </p>
            </div>
          </div>

          <p className="px-2 d-flex justify-content-center mx-auto text-center fontLight my-0 py-0">
            OR
          </p>

          <p className="mx-2 text-center fontLight my-0 py-0">
            Leave your Information below
          </p>
        </div>

        <Modal.Body className="contact-modal-body mx-auto d-flex justify-content-center">
          <ContactForm handleClose={handleClose} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Buttonanimated;